import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface RaceHeaderWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setRaceHeaderWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css``;
    }
    return css`
        border-color: ${theme.star.raceCard.filters.type.borderColor};
        border-style: solid;
        border-width: 1px 1px 0 1px;
    `;
};

export const RaceHeaderWrapper = withConfig(theme => styled('div', { label: 'RaceHeaderWrapper' })<RaceHeaderWrapperPropsType>`
    ${({ variant }): SerializedStyles=> setRaceHeaderWrapper(variant, theme)};
    background: ${theme.star.raceCard.details.bgColor};
    position: relative;
    padding: 6px 8px 8px;
`);

export const RaceHeaderDetails = styled('header', { label: 'RaceHeaderDetails' })`
    padding: 6px 8px 8px;
`;

interface RaceHeaderPropsType {
    isFinishedRace: boolean;
}

export const RaceHeaderDetailsHeader = withConfig(theme => styled('h4', { label: 'RaceHeaderDetailsHeader' })<RaceHeaderPropsType>`
    align-items: center;
    color: ${({ isFinishedRace }): string => isFinishedRace ? theme.star.raceCard.stats.txtColor : 'inherit'};
    display: flex;
    font-size: ${theme.star.fontSize.regular};
    font-weight: ${theme.star.fontWeight.bold};
    gap: 8px;
    line-height: 1.5;
    margin: 0;
    @media ${theme.star.mediaQuery.tablet} {
        font-size: ${theme.star.fontSize.xMedium};
        line-height: 1.4;
    }
`);

export const RaceHeaderDetailsData = withConfig(theme => styled('h4', { label: 'RaceHeaderDetailsData' })<RaceHeaderPropsType>`
    align-items: center;
    color: ${({ isFinishedRace }): string => isFinishedRace ? theme.star.raceCard.stats.txtColor : 'inherit'};
    display: flex;
    flex-flow: row wrap;
    font-size: ${theme.star.fontSize.xMedium};
    font-weight: ${theme.star.fontWeight.bold};
    gap: 8px;
    line-height: 1.4;
    margin: 0;
`);

export const ActionButtonWrapper = styled('div', { label: 'ActionButtonWrapper' })`
    display: flex;
    align-items: center;
    gap: 4px;
`;
